import {Route} from '@angular/router';
import {LandComponent} from '@app/features/land/land.component';

export const landRoute :Route[]= [
  {
    path: "",
    component : LandComponent,
    children : [
      {
        path: 'add',
        loadComponent: () => import('./pages/add-edit-land/add-edit-land.component'),
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./pages/add-edit-land/add-edit-land.component'),
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/view-land/view-land.component'),
      },
    ]
  }
]
